import type { EditorView } from "@codemirror/basic-setup";
import type { Accessible } from "@src/common/AccessibleStore";
import { accessible } from "@src/common/AccessibleStore";


export enum EditorPlaybackControlOwnership {
    NONE = 0,
    CONTROL = 1,
    TIMELINE = 2,
    INTERACTION = 3,
}

export enum EditorInteractionPointControlOwnership {
    NONE = 0,
    EDITOR = 1,
    TIMELINE = 2,
}

export type EditorStoreType = {
    currentTimelineSizingFactor: Accessible<number>,
    currentPlaybackControlOwnership: EditorPlaybackControlOwnership,
    currentTimelineTrackDisplayOffset: Accessible<number>,
    currentEditorInteractionPointControlOvership: EditorInteractionPointControlOwnership,
    currentCodeMirrorEditor: EditorView | undefined,
}

// NOTE: factor maps 10m(600s)~1s to 0~1 in a logarithmic manner.
// the function is y=log_600(x) whose inversion is x = 600^y

function _Editor() {
    const { subscribe, getValue, set, update } = accessible<EditorStoreType>({
        currentTimelineSizingFactor: accessible(1),
        currentPlaybackControlOwnership: EditorPlaybackControlOwnership.NONE,
        currentTimelineTrackDisplayOffset: accessible(161),
        currentEditorInteractionPointControlOvership: EditorInteractionPointControlOwnership.NONE,
        currentCodeMirrorEditor: undefined,
    });

    return {
        subscribe,
        getValue,
        reset: () => {
            getValue().currentTimelineSizingFactor.set(1);
            getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.NONE;
            getValue().currentTimelineTrackDisplayOffset.set(161);
            getValue().currentEditorInteractionPointControlOvership = EditorInteractionPointControlOwnership.NONE;
        },
        getSegmentLength: () => {
            return Math.pow(600, 1 - getValue().currentTimelineSizingFactor.getValue());
        },
        setTimelineSizingFactor: (x: number) => {
            getValue().currentTimelineSizingFactor.set(x);
        },
    }
}

export default _Editor();

